import { combineReducers } from '@reduxjs/toolkit'
import mentorshipReducer from './mentorship'
import logReducer from './log'

const combinedReducer = combineReducers({
  mentorship: mentorshipReducer,
  log: logReducer,
})

export default combinedReducer
